export const isCustomerActive = (customer) =>
  customer?.is_active === true ||
  customer?.isActive === true ||
  customer?.active === true;

export const getCustomerDisplayName = (customer) =>
  customer?.customer_name || customer?.orgcode || "this customer";
